import { Injectable } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { activityInput} from "../models";


@Injectable()
export class InputValidationService {
  inputFormCtlAndObj = {};
  constructor() {}

  getInputFormCtlAndObjMap(inputControl: UntypedFormControl, inputObj: activityInput) {
   return {inputControl, inputObj};
  }
}


